var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"app-icon",style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),domProps:{"innerHTML":_vm._s(_vm.svgContent)}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }